import type { ReactNode } from 'react';
import { useShouldRenderAds } from '@/lib/adsConfig';

interface AdFrameProps {
  children: ReactNode;
  className?: string;
}

/**
 * Spacing wrapper that collapses to null when ads are not rendering,
 * so empty mb/my parents do not leave layout gaps.
 */
const AdFrame = ({ children, className }: AdFrameProps) => {
  const shouldRender = useShouldRenderAds();
  if (!shouldRender) return null;
  return <div className={className}>{children}</div>;
};

export default AdFrame;
